import { TSortBy, TCountOfItems, IFilterValues, TTypeOfModalWindow } from './categoryContext';
import { ICategory, TCategoryType } from 'types';

export enum CategoryActionTypes {
	SET_CATEGORIES = 'SET_CATEGORIES',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_IDS_SELECTED_CATEGORY_TYPES = 'SET_IDS_SELECTED_CATEGORY_TYPES',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface ISetCategories {
	type: CategoryActionTypes.SET_CATEGORIES;
	payload: {
		categories: ICategory;
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface IChangeSearchString {
	type: CategoryActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: string;
	};
}

interface ISetIDCustomer {
	type: CategoryActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: Nullable<string>;
	};
}

interface ISetIDRestaurant {
	type: CategoryActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: Nullable<string>;
	};
}

interface ISetIDsSelectedCategoryType {
	type: CategoryActionTypes.SET_IDS_SELECTED_CATEGORY_TYPES;
	payload: {
		IDsSelectedCategoryTypes: TCategoryType[];
	};
}

interface IResetSelectedControls {
	type: CategoryActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: CategoryActionTypes.SET_SORT_BY;
	payload: {
		sortBy: TSortBy;
	};
}

interface ISetCountOfItems {
	type: CategoryActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: TCountOfItems;
	};
}

interface IChangeCurrentPage {
	type: CategoryActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: number;
	};
}

interface ISetIDForDeletion {
	type: CategoryActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: string;
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface IChangeTypeOfModalWindow {
	type: CategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface ISetFiltersFromQueryString {
	type: CategoryActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TCategoryAction =
	| ISetCategories
	| IChangeSearchString
	| ISetIDCustomer
	| ISetIDRestaurant
	| ISetIDsSelectedCategoryType
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString;
